import { Modal } from 'ant-design-vue';
export const allStateModels = [{
  model: 'list_JS',
  label: '列表模型',
  labelWithId: '列表模型（list_JS）',
  src: 'https://vfiles.gtimg.cn/vupload/20210802/1580111627906214587.png',
  desc: '调用list接口，主要用于渲染列表组件，支持分页、过滤、排序等功能',
  defaultTplTypes: ['list', 'universal', 'universal_read']
}, {
  model: 'list_JS',
  usage: 'local',
  label: '列表模型-本地分页',
  labelWithId: '列表模型-本地分页（list_JS）',
  src: 'https://vfiles.gtimg.cn/vupload/20210802/1580111627906214587.png',
  desc: '当list接口不支持分页时推荐使用，支持一次性拉取全部数据，在浏览器端本地进行分页、过滤、排序等功能',
  recommend: () => false,
  async confirmSelect(collection) {
    const content = collection.type === 'http' ? '若【list】接口支持服务端分页，则无需使用【列表模型 - 本地分页】，建议使用普通的【列表模型】即可。' : 'DB类型数据源支持服务端分页，无需使用【列表模型 - 本地分页】，建议使用普通的【列表模型】即可。';
    return new Promise(r => {
      Modal.confirm({
        title: '提示',
        content,
        okText: '使用本地分页模型',
        cancelText: '放弃使用',
        onOk: () => r(true),
        onCancel: () => r(false)
      });
    });
  }
}, {
  model: 'rv_list_JS',
  label: '列表模型-行级版本',
  labelWithId: '列表模型-行级版本（rv_list_JS）',
  src: 'https://vfiles.gtimg.cn/vupload/20210802/1580111627906214587.png',
  desc: '支持行级版本管理的list模型',
  defaultTplTypes: ['list', 'universal', 'universal_read']
}, {
  model: 'rv_form_JS',
  label: '表单模型-行级版本',
  labelWithId: '表单模型-行级版本（rv_form_JS）',
  src: 'https://vfiles.gtimg.cn/vupload/20210802/1580111627906214587.png',
  desc: '支持行级版本管理的表单模型',
  defaultTplTypes: ['form']
}, {
  model: 'form_JS',
  label: '表单模型',
  labelWithId: '表单模型（form_JS）',
  src: 'https://vfiles.gtimg.cn/vupload/20210802/0472e21627906142508.png',
  desc: '调用create/update/get等接口，主要用于生成创建/编辑数据的表单组件',
  defaultTplTypes: ['form']
}, {
  model: 'any_JS',
  label: '简单模型',
  labelWithId: '简单模型（any_JS）',
  defaultTplTypes: ['any']
}, {
  model: 'list',
  label: '列表模型',
  labelWithId: '列表模型（list）',
  src: 'https://vfiles.gtimg.cn/vupload/20210802/1580111627906214587.png'
}, {
  model: 'form',
  label: '表单模型',
  labelWithId: '表单模型（form）',
  src: 'https://vfiles.gtimg.cn/vupload/20210802/0472e21627906142508.png'
}, {
  model: 'any',
  label: '简单模型',
  labelWithId: '简单模型（any）'
}];
export const combineDataModels = allStateModels.filter(item => ['list', 'form'].includes(item.model));
export function getSupportedModels(models, collection) {
  const isCombineData = collection.type === 'combineData';
  const modelInfos = allStateModels.filter(item => models.includes(item.model));
  if (isCombineData) {
    // 组合数据源只支持老版本数据源
    return combineDataModels;
  }
  // 只允许选择新的数据源
  return modelInfos.filter(item => isJSStateModel(item.model));
}
/**
 * 内置接口list之类都没有配置，只配置了custom时，使用该model
 */
export function getSupportedModelByTplType(tplType) {
  return allStateModels.find(item => {
    var _item$defaultTplTypes;
    return (_item$defaultTplTypes = item.defaultTplTypes) === null || _item$defaultTplTypes === void 0 ? void 0 : _item$defaultTplTypes.includes(tplType);
  });
}
export function isJSStateModel(model) {
  return ['list_JS', 'form_JS', 'any_JS', 'rv_list_JS', 'rv_form_JS'].includes(model);
}
export function getStateModels(collection) {
  if (collection.type === 'combineData') {
    return ['list', 'form'];
  }
  const checks = [{
    model: ['list_JS'],
    cgis: ['list', 'count']
  }, {
    model: ['form_JS'],
    cgis: ['create', 'update', 'get', 'delete']
  }, {
    model: ['any_JS'],
    cgis: ['request']
  }, {
    model: ['rv_list_JS', 'rv_form_JS'],
    cgis: ['publish', 'prodList', 'rollback', 'historyList']
  }];
  const {
    cgiInfo
  } = collection;
  const models = checks.reduce((prev, item) => {
    if (item.cgis.some(name => cgiInfo === null || cgiInfo === void 0 ? void 0 : cgiInfo[name])) {
      prev.push(...item.model);
    }
    return prev;
  }, []);
  return models;
}
/**
 * 根据老的model推导新的model list => list_JS
 */
export function getStateModelsByOldModal(collection, models) {
  if (!models) {
    return [];
  }
  if (collection.type === 'combineData') {
    return models;
  }
  if (models.some(item => isJSStateModel(item))) {
    // 有新的模型就不需要兼容
    return models;
  }
  // 只有老模型，需要把新模型加上
  const newModels = models.map(item => `${item}_JS`);
  return [...models, ...newModels];
}
//# sourceMappingURL=getStateModels.js.map
